<template>
  <table class="table params-table">
    <thead>
      <tr>
        <th>Параметр</th>
        <th>Тип</th>
        <th>Обязательный</th>
        <th>null?</th>
        <th>Значение по-умолчанию</th>
        <th>Описание</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="param in params"
        :key="param.attr"
      >
        <td>{{ param.attr }}</td>
        <td>{{ param.type }}</td>
        <td>{{ param.required ? '+': '-' }}</td>
        <td>{{ param.allow_none ? '+' : '-' }}</td>
        <td>
          {{ param.default === null ? '-' : JSON.stringify(param.default, null, 2) }}
        </td>
        <td>{{ param.description }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'ParamsTable',
  props: {
    params: { type: Array, required: true },
  },
}
</script>
